import initQuotesWidget from '../common/scripts/quotes_widget/quotes_widget'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initQuotesWidget()
  })
} else {
  initQuotesWidget()
}
